import React from "react";
import ScrollToTop from "../../components/scroll-to-top";
import SEO from "../../components/seo";
import AboutContainer from "../../containers/about";
// import BrandContainer from "../containers/global/brand/index";
// import FunFactContainer from "../containers/global/funfact";
// import IconBoxContainer from "../containers/global/icon-box";
import NewsletterArea from "../../containers/global/newsletter";
import PageBanner from "../../containers/global/page-banner";
// import TestimonialReverse from "../containers/global/testimonial-reverse";
// import ServiceListContainer from "../containers/service/service-list";
import Footer from "../../layouts/footer";
import Header from "../../layouts/header";
import Layout from "../../layouts/index";
// import data from "../data/about_us.json";

const AboutPage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO title="About Us" />
                <div className="wrapper">
                    <Header />
                    <PageBanner
                        title="About Us"
                        image="/images/banner/page/leadership.png"
                    />

                    <div className="about-us position-relative pb-5 pt-5"></div>

                    <div className=" brand-section y-background-color mb-10 pt-5">
                        <div className="container">
                            <div className="section-title text-center">
                                <h2 className="text-primary">
                                    <b>
                                        Small businesses are the backbone of the
                                        nation.
                                        <li>We are their backbone.</li>
                                    </b>
                                </h2>
                                <p className="b-color text-center">
                                    <li>
                                        NeoGrowth funds the big dreams of small
                                        businesses. One simple piece of data
                                        fuels our mission:
                                    </li>

                                    <li>
                                        50% of India’s creditworthy SMEs do not
                                        receive loans because of outdated
                                        underwriting methods.
                                    </li>
                                    <li>
                                        This is the 50% we serve. We’ve served
                                        them by disbursing over USD 1 billion in
                                        loans so far.
                                    </li>
                                    <li>
                                        Inclusion is something we take very
                                        seriously, and we’ve been practicing
                                        what we preach since 2013. We assess
                                        creditworthiness by analysing
                                        fundamental business numbers that speak
                                        for themselves. Socio-economic status,
                                        gender, level of education and other
                                        discriminators just don’t matter.
                                    </li>
                                    <li>
                                        This vision led to NeoGrowth being the
                                        founding member of the Digital Lender’s
                                        Association of India, an ecosystem for
                                        revolutionaries in the Indian Fintech
                                        space.
                                    </li>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="container ">
                        <h2 className="text-primary ">
                            <b>
                                Everyone deserves a chance to grow, <br />
                                And we’ll give you the freedom to grow your way.
                            </b>
                        </h2>
                        <p className="text-gray-800 mt-4">
                            Each business we partner with becomes part of the
                            NeoGrowth family, and our constantly growing family
                            currently includes 25,000+ businesses and 500+
                            employees to serve them relentlessly. We’ve taken
                            our flexible, new-age philosophy to 25+ Indian
                            cities so far, and are looking to grow pan India:
                            just like the businesses we partner with, we believe
                            there’s no limit to our growth. You can locate our
                            branches{" "}
                            <a
                                href={
                                    process.env.PUBLIC_URL +
                                    "/customer-services"
                                }
                                className="text-primary"
                                rel="noopener noreferrer"
                            >
                                here
                            </a>
                            .
                        </p>

                        <h2 className="text-primary">
                            <b>New-age philosophy, new-age technology</b>
                        </h2>
                        <p className="text-gray-800 mt-4">
                            We don’t just want to make loans hassle-free. With
                            the right combination of product offerings and user
                            experience, we believe we can make it enjoyable as
                            well. Cutting-edge analytics, our in-house app for
                            customers and real-time interactions allows us to
                            constantly grow.
                        </p>
                        <h2 className="text-primary text-start">
                            <b>
                                The seed for NeoGrowth’s journey was planted by…
                            </b>
                        </h2>
                    </div>
                </div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <p className="text-gray-800 mt-4">
                                <li>
                                    Our promoters Dhruv Khaitan and P.K.
                                    Khaitan, as well as a team of renowned
                                    investors who believed in our mission:
                                    Omidyar Network, Aspada Investment Company,
                                    Khosla Impact, Accion Frontier Inclusion
                                    Fund – Quona Capital, IIFL Seed Ventures
                                    Fund and Leapfrog Investments.
                                </li>
                                <li>
                                    NeoGrowth’s relentless customer focus can be
                                    credited to the entrepreneurial genes that
                                    the Khaitan brothers share. Together, they
                                    founded and managed Venture Infotek.
                                </li>
                                <li>
                                    Venture Infotek was a pioneer and leader in
                                    the Indian e-payments industry and managed
                                    merchant transactions for acquiring banks as
                                    well as credit card issuers and large
                                    loyalty programs.
                                </li>
                                <li>
                                    They divested the company to a large
                                    European IT Services company in 2010. By
                                    then, Venture Infotek was the market leader
                                    in e-payments processing with a 40% share of
                                    all India card volume.
                                </li>
                            </p>
                        </div>

                        <div className="col-md-6">
                            <div
                                className="overflow-hidden w-100 h-100"
                                style={{ borderRadius: 20 }}
                            >
                                <img
                                    src="/images/about/latestbann__Recovered.png"
                                    alt=""
                                    className="w-100 h-100 object-fit-cover d-block"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <br></br>

                <div className="blog-section g-background-color mb-10 pt-5">
                    <div className="container">
                        <div className="section-title text-center">
                            <h2 className="text-primary">
                                <b>Our Mission</b>
                            </h2>
                            <p className="b-color text-center ">
                                To fund small businesses by leveraging the
                                digital ecosystem. Our financing not only helps
                                our clients grow but also creates a positive
                                impact.
                            </p>
                        </div>

                        <div className="section-title text-center mt-5">
                            <h2 className="text-primary">
                                <b>Core Values</b>
                            </h2>
                            <p className="b-color text-center">
                                NeoGrowth is a values driven company and that is
                                reflected in the following three values. All our
                                products, processes and services are built
                                around these values and we proudly adhere to it.
                                It is what makes us tick in the competitive
                                marketplace that we operate in.
                            </p>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="blog-card ">
                                    <div className="thumb text-center">
                                        <div className="mb-3">
                                            <img
                                                src="/images/about/Accountabilty 2.png"
                                                alt="Accountability"
                                                width="60"
                                            />
                                        </div>
                                        <br></br>
                                        <div className="blog-content text-center">
                                            <h3 className="title mb-2">
                                                Accountability
                                            </h3>
                                            <p>
                                                We empower our people to own
                                                their work and results
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="blog-card ">
                                    <div className="thumb text-center">
                                        <div className="mb-3">
                                            <img
                                                src="/images/about/Customer focus 1.png"
                                                alt="Customer Focus"
                                                width="60"
                                            />
                                        </div>
                                        <br></br>
                                        <div className="blog-content text-center">
                                            <h3 className="title mb-2">
                                                Customer Focus
                                            </h3>
                                            <p>
                                                Our customers’ success is at the
                                                heart of all we do
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="blog-card ">
                                    <div className="thumb text-center">
                                        <div className="mb-3">
                                            <img
                                                src="/images/about/Innovation 2.png"
                                                alt="Innovation"
                                                width="60"
                                            />
                                        </div>
                                        <br></br>
                                        <div className="blog-content text-center">
                                            <h3 className="title mb-2">
                                                Innovation
                                            </h3>
                                            <p>
                                                Pioneering new-age financial
                                                solutions is in our DNA
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container ">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <h3 className="text-primary text-start mb-4">
                                <b>
                                    The legal assurance to know you’re in good
                                    hands
                                </b>
                            </h3>
                            <p className="text-gray-800 mt-4">
                                <li>
                                    We are an NBFC registered with the RBI and
                                    started commercial operations in 2013.
                                </li>
                                <li>
                                    NeoGrowth has a valid Certificate of
                                    Registration last updated on September 12,
                                    2014, issued by the Reserve Bank of India
                                    under section 45-I A of the Reserve Bank of
                                    India Act,1934.
                                </li>
                                <li>
                                    However the RBI does not accept any
                                    responsibility or guarantee about the
                                    present position as to the financial
                                    soundness of the company or for the
                                    correctness of any of the statements or
                                    representations made or opinion expressed by
                                    the company and for repayment of deposits /
                                    discharge of liabilities by the company.
                                </li>
                            </p>
                        </div>
                        <div className="col-md-6">
                            <iframe
                                width="100%"
                                height="315"
                                src="https://www.youtube.com/embed/lfOwq9fOwuY"
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowfullscreen
                            ></iframe>
                        </div>
                    </div>
                </div>
                <br></br>
                <br></br>

                <div className="section-title text-center">
                    <h2 className="text-primary">
                        <b>Contact Us</b>
                    </h2>
                </div>
                <br></br>

                <div className="col-12">
                    <div
                        id="grid"
                        className="grid row mb-n8 justify-content-center"
                    >
                        {/* <div className="grid-item mb-7">
                            <div
                                className="feature-card bg-light text-center"
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                }}
                            >
                                <span className="card-shape card-shape-light"></span>
                                <span className="card-shape card-shape-dark"></span>
                                <h4 className="title ">Investor Grievances</h4>
                                <ul className="list-unstyled">
                                    <li>
                                        <b>Mr. Deepak Goswami</b>
                                    </li>
                                    <li>Chief Financial Officer</li>
                                    <li>
                                        NeoGrowth Credit Pvt. Ltd.{" "}
                                        <li>Times Square, Tower E,</li>
                                        <li>9th Floor, Andheri-Kurla Road,</li>
                                        <li>
                                            <li>Marol, Andheri East,</li>
                                            <li> Mumbai - 400059,</li>
                                            Maharashtra
                                        </li>
                                    </li>

                                    <li>
                                        <a
                                            className="address-link"
                                            href="tel:+022-49290500"
                                        >
                                            <i className="fa fa-phone-square">
                                                &nbsp;&nbsp;
                                            </i>
                                            022-49290500
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto:deepak.goswami@neogrowth.in">
                                            <i className="fa fa-envelope">
                                                &nbsp;
                                            </i>
                                            deepak.goswami@neogrowth.in
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div> */}

                        <div className="grid-item mb-7">
                            <div
                                className="feature-card bg-light text-center"
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                }}
                            >
                                {/* <span className="card-shape card-shape-light"></span>
                                <span className="card-shape card-shape-dark"></span> */}
                                <h3 className="title ">Debenture Trustee</h3>
                                <ul className="list-unstyled">
                                    <li>
                                        <b>Mr. Umesh Salvi</b>
                                    </li>
                                    <li>Managing Director</li>
                                    <li>
                                        <li>Catalyst Trusteeship Limited </li>
                                        <li>GDA House, Plot No. 85 ,</li>
                                        <li>Bhusari Colony (Right),</li> Paud
                                        Road, Pune –<li>411038</li>
                                    </li>

                                    <li>
                                        <a
                                            className="address-link"
                                            href="tel:+022–49220502"
                                            aria-label="Call 022 49220502"
                                        >
                                            <i
                                                className="fa fa-phone-square"
                                                aria-hidden="true"
                                            >
                                                &nbsp;&nbsp;
                                            </i>
                                            022–49220502
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="mailto:umesh.salvi@ctltrustee.com"
                                            aria-label="Send email to umesh.salvi@ctltrustee.com"
                                        >
                                            <i
                                                className="fa fa-envelope"
                                                aria-hidden="true"
                                            >
                                                &nbsp;
                                            </i>
                                            umesh.salvi@ctltrustee.com
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="catalysttrustee.com/"
                                            target="_blank"
                                            aria-label="Visit website (opens in a new tab)"
                                        >
                                            {" "}
                                            <i
                                                className="fa fa-globe"
                                                aria-hidden="true"
                                            >
                                                &nbsp;
                                            </i>
                                            https://catalysttrustee.com/
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="grid-item mb-7">
                            <div
                                className="feature-card bg-light text-center"
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                }}
                            >
                                {/* <span className="card-shape card-shape-light"></span>
                                <span className="card-shape card-shape-dark"></span> */}
                                <h3 className="title">
                                    Principal Nodal Officer
                                </h3>
                                <ul className="list-unstyled">
                                    <li>
                                        <b>Mr. Yogesh Nakhwa</b>
                                    </li>
                                    <li>
                                        NeoGrowth Credit Private Limited
                                        <li>
                                            Times Square, Tower E,9th Floor,
                                        </li>
                                        <li>Andheri-Kurla Road,</li>
                                        <li>Marol, Andheri East,</li>
                                        Mumbai - 400059, Maharashtra
                                    </li>
                                    <li>
                                        <a
                                            className="address-link"
                                            href="tel:+022-49219930"
                                            aria-label="Call 022 49219930"
                                        >
                                            <i
                                                className="fa fa-phone-square"
                                                aria-hidden="true"
                                            >
                                                &nbsp;&nbsp;
                                            </i>
                                            022-49219930
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="mailto:nodalofficer@neogrowth.in"
                                            aria-label="Send email to nodalofficer@neogrowth.in"
                                        >
                                            <i
                                                className="fa fa-envelope"
                                                aria-hidden="true"
                                            >
                                                &nbsp;
                                            </i>
                                            nodalofficer@neogrowth.in
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="grid-item mb-7">
                            <div
                                className="feature-card bg-light text-center"
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                }}
                            >
                                {/* <span className="card-shape card-shape-light"></span>
                                <span className="card-shape card-shape-dark"></span> */}
                                <h3 className="title ">
                                    Grievance Redressal Officer
                                </h3>
                                <ul className="list-unstyled">
                                    <li>
                                        <b>Mrs. Bijal Patwa</b>
                                    </li>
                                    <li>
                                        NeoGrowth Credit Private Limited
                                        <li>
                                            Times Square, Tower E, 9th Floor,
                                        </li>
                                        <li>Andheri - Kurla Road,</li>
                                        <li>Marol, Andheri East,</li>
                                        <li>Mumbai - 400059, Maharashtra</li>
                                    </li>
                                    <li>
                                        {" "}
                                        <a
                                            className="address-link"
                                            href="tel:+022-49219999"
                                            aria-label="Call 022 49219999"
                                        >
                                            <i
                                                className="fa fa-phone-square"
                                                aria-hidden="true"
                                            >
                                                &nbsp;&nbsp;
                                            </i>
                                            022-49219999
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="mailto:grievanceofficer@neogrowth.in"
                                            aria-label="Send email to umesh.salvi@ctltrustee.com"
                                        >
                                            <i
                                                className="fa fa-envelope"
                                                aria-hidden="true"
                                            >
                                                &nbsp;
                                            </i>
                                            grievanceofficer@neogrowth.in
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <br></br>

                <div className="col-12">
                    <div
                        id="grid"
                        className="grid row mb-n8 justify-content-center"
                    >
                        <div className="grid-item mb-7">
                            <div
                                className="feature-card bg-light text-center"
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                }}
                            >
                                {/* <span className="card-shape card-shape-light"></span>
                                <span className="card-shape card-shape-dark"></span> */}
                                <h3 className="title ">
                                    Registrar and Transfer Agent
                                </h3>
                                <ul className="list-unstyled">
                                    <li>
                                        <b>Mr. S.P Venugopal</b>
                                    </li>
                                    <li>DGM – Corporate Registry</li>
                                    <li>
                                        KFIN Technologies Limited Karvy
                                        Selenium, Tower-B,Plot No.31&32,
                                        Financial District,Nanakramguda,
                                        Serilingampally Mandal,Hyderabad –
                                        500032
                                    </li>

                                    <li>
                                        <a
                                            className="address-link"
                                            href="tel:+040-67162222"
                                            aria-label="Call 040 67162222"
                                        >
                                            <i
                                                className="fa fa-phone-square"
                                                aria-hidden="true"
                                            >
                                                &nbsp;&nbsp;
                                            </i>
                                            040-67162222
                                        </a>
                                    </li>

                                    <li>
                                        <a
                                            href="mailto:yenu.sp@karvy.com"
                                            aria-label="Send email to umesh.salvi@ctltrustee.com"
                                        >
                                            <i
                                                className="fa fa-envelope"
                                                aria-hidden="true"
                                            >
                                                &nbsp;
                                            </i>
                                            yenu.sp@karvy.com
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="kfintech.com"
                                            target="_blank"
                                            aria-label="Visit website (opens in a new tab)"
                                        >
                                            {" "}
                                            <i
                                                className="fa fa-globe"
                                                aria-hidden="true"
                                            >
                                                &nbsp;
                                            </i>
                                            https://kfintech.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="grid-item mb-7">
                            <div
                                className="feature-card bg-light text-center"
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                }}
                            >
                                {/* <span className="card-shape card-shape-light"></span>
                                <span className="card-shape card-shape-dark"></span> */}
                                <h3 className="title ">Debenture Trustee</h3>

                                <ul className="list-unstyled">
                                    <li>
                                        <b>Mr. Kaustubh Kulkarni</b>
                                    </li>
                                    <li>Executive Director</li>
                                    <li>
                                        Beacon Trusteeship Limited 7A&B,
                                        Siddhivinayak Chambers,Opp MIG{" "}
                                        <li>
                                            Cricket Club,Gandhi Nagar,Bandra
                                        </li>
                                        (East), Mumbai,Maharashtra-400051
                                    </li>
                                    <li>
                                        <a
                                            className="address-link"
                                            href="tel:+022–26558759"
                                            aria-label="Call 022 26558759"
                                        >
                                            <i
                                                className="fa fa-phone-square"
                                                aria-hidden="true"
                                            >
                                                &nbsp;&nbsp;
                                            </i>
                                            022–26558759
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="mailto:kk@beacontrustee.co.in"
                                            aria-label="Send email to kk@beacontrustee.co.in"
                                        >
                                            <i
                                                className="fa fa-envelope"
                                                aria-hidden="true"
                                            >
                                                &nbsp;
                                            </i>
                                            kk@beacontrustee.co.in
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="beacontrustee.co.in"
                                            target="_blank"
                                            aria-label="Visit website (opens in a new tab)"
                                        >
                                            <i
                                                className="fa fa-globe"
                                                aria-hidden="true"
                                            >
                                                &nbsp;
                                            </i>
                                            https://beacontrustee.co.in
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <br></br>
                <div className="container ">
                    <div className="col-md-12">
                        <br></br>
                        <h2 className="text-primary text-center">
                            Contact information for Investor Grievances:
                        </h2>
                        <div className="pb-0">
                            <u>Redressal of Investor Grievances:</u>
                            <br></br>
                            <div className="pt-3">
                                An investor having grievance/ complaint shall
                                first write to:
                            </div>
                        </div>
                        <span className="text-dark">
                            <b>Mr. Deepak Goswami</b>
                        </span>
                        <br></br>
                        <ul className="d-block ">
                            <li>Chief Financial Officer</li>
                            <li>
                                Times Square, Tower E, 9th Floor, Andheri-Kurla
                                Road, Marol, Andheri East, Mumbai- 400059,
                                Maharashtra.
                            </li>
                            <li>
                                <a href="tel:022-49290500">
                                    <span className="text-dark">Tel: </span>{" "}
                                    022-49290500{" "}
                                </a>
                            </li>
                            <li>
                                <a href="mailto:ravi.kumar@neogrowth.in">
                                    {" "}
                                    <span className="text-dark">
                                        {" "}
                                        Email ID:
                                    </span>{" "}
                                    deepak.goswami@neogrowth.in
                                </a>
                            </li>
                        </ul>
                        <div className="pt-3">
                            If the grievance is not redressed satisfactorily,
                            the investor may escalate the same through the
                            SCORES Portal at{" "}
                            <a
                                href="https://scores.sebi.gov.in/"
                                target="_blank"
                                className="text-green"
                                rel="noreferrer"
                            >
                                {" "}
                                https://scores.sebi.gov.in/
                            </a>
                            . After exhausting all the available options for
                            resolution of the grievance, if the investor is
                            still not satisfied with the outcome, dispute
                            resolution can be initiated through the ODR Portal
                            at{" "}
                            <a
                                href="https://smartodr.in/"
                                target="_blank"
                                className="text-green"
                                rel="noreferrer"
                            >
                                https://smartodr.in/
                            </a>
                            .
                        </div>
                        <div>
                            The SEBI Master Circular w.r.t. Online Dispute
                            Resolution (ODR) is available at{" "}
                            <a
                                href="https://www.sebi.gov.in/legal/master-circulars/dec-2023/master-circular-for-online-resolution-of-disputes-in-the-indian-securities-market_80236.html"
                                target="_blank"
                                className="text-green"
                                rel="noreferrer"
                            >
                                {" "}
                                SEBI | Master Circular for Online Resolution of
                                Disputes in the Indian Securities Market
                            </a>
                            .
                        </div>
                    </div>
                </div>

                <br></br>

                <Footer />
                <ScrollToTop />
            </Layout>
        </React.Fragment>
    );
};

export default AboutPage;
